import { lazy, useEffect } from 'react';

import { observer } from 'mobx-react';
import { Outlet, useSearchParams } from 'react-router-dom';

import { MinigamesDialog } from '../components/Dialogs/MinigamesDialog/MinigamesDialog';
import { FeatureFlag } from '../components/FeatureFlag/FeatureFlag';
import GameIframe from '../components/GameIframe/GameIframe';
import { FreeSpinDialog } from '../components/UserFreeSpins/FreeSpinsDialog';
import { UserSnappyGiftsDialog } from '../components/UserSnappyGifts/UserSnappyGiftsDialog';
import { useForceKycReactionDialog } from '../features/player-kyc/useForceKycReactionDialog';
import { usePocReactionDialog } from '../features/poc/PocReactionDialog/usePocReactionDialog';
import { useBingoDataInitializer } from '../hooks/queries/useBingoDataInitializer';
import { useSubscriptionDataInitializer } from '../hooks/queries/useSubscriptionDataInitializer';
import RiveFilePreloaderGroup from '../hooks/rive/RiveFilePreloaderGroup';
import { useCcLowBalance } from '../hooks/useCcLowBalance';
import useClosePopupsShortcut from '../hooks/useClosePopupsShortcut';
import { useThemeByCoinType } from '../hooks/useThemeByCoinType';
import { auth } from '../services/auth';
import { useStores } from '../stores/useStores';

const AccountConflictDialog = lazy(() => import('../components/Dialogs/AccountConflictDialog/AccountConflictDialog'));

const Casino = observer(() => {
  const { authStore, minigamesStore, userFreeSpinsStore, portalStore, userSnappyGiftsStore } = useStores();

  const [_, setSearchParams] = useSearchParams();

  useCcLowBalance();
  usePocReactionDialog();
  useForceKycReactionDialog();
  useClosePopupsShortcut();
  useThemeByCoinType();

  useBingoDataInitializer();
  useSubscriptionDataInitializer();

  useEffect(() => {
    if (auth.isAuthConflictListenersEmpty) {
      auth.addAuthConflictListener((email) => {
        authStore.clearLandingKey(setSearchParams);
        portalStore.openPortal(AccountConflictDialog, { email });
      });
    }
  }, [portalStore, authStore, setSearchParams]);

  return (
    <>
      <RiveFilePreloaderGroup />
      {authStore.authorized && authStore.isAuthenticationFlowDone && <GameIframe />}
      {userFreeSpinsStore.isDialogOpen && (
        <FeatureFlag defaultValue={true} flagKey="user_free_spins_widgets_feature">
          <FreeSpinDialog />
        </FeatureFlag>
      )}
      {userSnappyGiftsStore.isDialogOpen && <UserSnappyGiftsDialog />}
      {minigamesStore.isDialogOpen && <MinigamesDialog />}
      <Outlet />
    </>
  );
});

export default Casino;
